import { useMemo } from "react"
import { useSelector } from "react-redux"
import { VERIFICATION_STATUS } from "layoutsV2/pro/PersonalInfoLayout/constants"

const useActiveGuide = () => {
  const { active, account_status, verification_status } = useSelector((state) => state.user?.guide) || {}
  const isSelfDeactive = useMemo(() => account_status === "deactivated", [account_status])
  const isActive = active && !isSelfDeactive
  const isPending = verification_status === VERIFICATION_STATUS.PENDING
  const isInProgress = verification_status === VERIFICATION_STATUS.IN_PROGRESS
  const isApproved = verification_status === VERIFICATION_STATUS.APPROVED
  const isRejected = verification_status === VERIFICATION_STATUS.REJECTED
  return { isActive, isPending, isInProgress, isApproved, isRejected }
}

export default useActiveGuide
